import React from "react";
import { useParams } from "react-router-dom";
import Header from "./header";

const OrderDetails = () => {
  const { orderId } = useParams();
  const navigation = [
    { name: "Informazioni Account", href: "/" },
    { name: "Ordini", href: "/abbonamenti" },
    { name: "Abbonamento", href: "#" },
    { name: "Pagamenti", href: "/arretrati" },
  ];

  const option = "Ordini";
  // Adesso puoi utilizzare orderId nel tuo componente
  console.log("Order ID:", orderId);

  return (
    <div className="bg-gray-100 min-h-screen">
      <Header />
      <div className="container mx-auto flex flex-col sm:flex-row sm:mt-8 justify-center items-center sm:justify-start sm:items-start bg-gresen-200">
        {/* Sidebar */}
        <div className="sm:w-[23%] bg-sred-500 p-8 rounded-lg flex justify-center w-full sm:justify-start">
          <ul className="w-screen lg: text-left text-sm space-y-2 flex sm:flex-col items-center sm:items-start bg-bluse-400">
            {navigation.map((item) => (
              <li key={item.name} className="w-full">
                <p
                  href="#"
                  onClick={() => alert("Funzione non ancora implementata")}
                  className={`block text-gray-700 font-semibold p-2 rounded ${
                    option === item.name
                      ? "bg-gray-300 shadow-[inset_0_0px_3px_rgba(0,0,0,0.2)]"
                      : ""
                  }`}
                >
                  {item.name}
                </p>
              </li>
            ))}
          </ul>
        </div>
        <div className="w-full sm:w-3/4 lg:mr-40 bg-white p-6 rounded-lg shadow-lg mt-4 md:mt-0 md:ml-4">
          {" "}
          <h2 className="text-2xl text-left font-bold mb-6">Dettagli Ordine</h2>
          <p>ID dell'Ordine: {orderId}</p>
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;
